
import useTrialConfigurationSourceData from "@/hooks/data/useTrialConfigurationSourceData";
import { createContext } from "react"

export interface ITrialConfigurationSourceDataContext extends ReturnType<typeof useTrialConfigurationSourceData> {
}

export const TrialConfigurationSourceDataContext = createContext<ITrialConfigurationSourceDataContext>({
    data: undefined,
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined }
});

export default TrialConfigurationSourceDataContext;